import { type PortalDeposit, type WalletInstructions } from '@/schemas/cashierSession.schema';

/**
 * Hand-written field comparison. A generic deep-equal would keep working and silently ignore a new
 * contract field. Destructuring with an empty rest makes a new field a compile error.
 */
export function depositsEqual(left: PortalDeposit | null, right: PortalDeposit | null): boolean {
  if (left === right) return true;
  if (left === null || right === null) return false;

  const {
    id,
    publicId,
    merchantId,
    traderId,
    playerRef,
    status,
    mode,
    amount,
    receivedAmount,
    currency,
    decimalPlaces,
    merchantOrderId,
    paymentMethodCode,
    providerReference,
    createdAt,
    expiresAt,
    verificationExpiresAt,
    updatedAt,
    returnUrl,
    ...rest
  } = left;
  const _exhaustive: Record<string, never> = rest;
  void _exhaustive;

  return (
    id === right.id &&
    publicId === right.publicId &&
    merchantId === right.merchantId &&
    traderId === right.traderId &&
    playerRef === right.playerRef &&
    status === right.status &&
    mode === right.mode &&
    amount === right.amount &&
    receivedAmount === right.receivedAmount &&
    currency === right.currency &&
    decimalPlaces === right.decimalPlaces &&
    merchantOrderId === right.merchantOrderId &&
    paymentMethodCode === right.paymentMethodCode &&
    providerReference === right.providerReference &&
    createdAt === right.createdAt &&
    expiresAt === right.expiresAt &&
    verificationExpiresAt === right.verificationExpiresAt &&
    updatedAt === right.updatedAt &&
    returnUrl === right.returnUrl
  );
}

export function walletInstructionsEqual(
  left: WalletInstructions | null,
  right: WalletInstructions | null,
): boolean {
  if (left === right) return true;
  if (left === null || right === null) return false;

  const {
    accountType,
    accountLabel,
    accountNumber,
    accountHolderName,
    qrImageUrl,
    bankCode,
    ...rest
  } = left;
  const _exhaustive: Record<string, never> = rest;
  void _exhaustive;
  return (
    accountType === right.accountType &&
    accountLabel === right.accountLabel &&
    accountNumber === right.accountNumber &&
    accountHolderName === right.accountHolderName &&
    qrImageUrl === right.qrImageUrl &&
    (bankCode ?? null) === (right.bankCode ?? null)
  );
}
